import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "lg:grid lg:grid-cols-12 lg:gap-x-5" }
const _hoisted_2 = { class: "px-0 py-3 sm:px-6 lg:col-span-3 lg:px-0 lg:py-0" }
const _hoisted_3 = {
  key: 0,
  class: "space-y-6 sm:px-6 lg:col-span-9 lg:px-0 h-full"
}
const _hoisted_4 = { class: "mb-0 z-100 rounded-lg bg-gray-100" }
const _hoisted_5 = { class: "flex flex-col sm:hidden w-full" }
const _hoisted_6 = { class: "inline-flex justify-between items-center w-full" }
const _hoisted_7 = { class: "font-semibold text-gray-800" }
const _hoisted_8 = {
  key: 1,
  class: "text-gray-700 px-1 text-sm font-medium whitespace-nowrap"
}
const _hoisted_9 = {
  key: 2,
  class: "text-gray-700 px-1 text-sm font-medium whitespace-nowrap"
}
const _hoisted_10 = {
  key: 3,
  class: "text-gray-700 px-1 text-sm font-medium whitespace-nowrap"
}
const _hoisted_11 = { class: "py-1" }
const _hoisted_12 = ["disabled", "onClick"]
const _hoisted_13 = { class: "items-center rounded-md bg-white p-0.5 flex gap-0.5" }
const _hoisted_14 = { class: "hidden sm:block" }
const _hoisted_15 = { class: "flex items-center border-b border-gray-200" }
const _hoisted_16 = { class: "-mb-px flex flex-1 space-x-6 xl:space-x-8" }
const _hoisted_17 = { class: "font-semibold text-gray-800" }
const _hoisted_18 = {
  key: 1,
  href: "#",
  class: "border-transparent text-gray-700 border-b-2 px-1 py-4 text-sm font-medium whitespace-nowrap"
}
const _hoisted_19 = {
  key: 2,
  href: "#",
  class: "border-transparent text-gray-700 border-b-2 px-1 py-4 text-sm font-medium whitespace-nowrap"
}
const _hoisted_20 = { class: "ml-2 hidden items-center gap-2 sm:flex" }
const _hoisted_21 = { class: "py-1" }
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = { class: "items-center rounded-md bg-white p-0.5 flex gap-0.5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditFolderComponent = _resolveComponent("EditFolderComponent")!
  const _component_ControlsMenuComponent = _resolveComponent("ControlsMenuComponent")!
  const _component_PeopleBlockComponent = _resolveComponent("PeopleBlockComponent")!
  const _component_PeoplePromoBlockComponent = _resolveComponent("PeoplePromoBlockComponent")!
  const _component_FoldersListComponent = _resolveComponent("FoldersListComponent")!
  const _component_PhotoUploaderV3Component = _resolveComponent("PhotoUploaderV3Component")!
  const _component_NewPhotoUploaderComponent = _resolveComponent("NewPhotoUploaderComponent")!
  const _component_ArrowUpTrayIcon = _resolveComponent("ArrowUpTrayIcon")!
  const _component_PencilSquareIcon = _resolveComponent("PencilSquareIcon")!
  const _component_BarsArrowDownIcon = _resolveComponent("BarsArrowDownIcon")!
  const _component_ChevronDownIcon20 = _resolveComponent("ChevronDownIcon20")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_Bars4Icon = _resolveComponent("Bars4Icon")!
  const _component_Squares2X2IconMini = _resolveComponent("Squares2X2IconMini")!
  const _component_PhotosListComponent = _resolveComponent("PhotosListComponent")!
  const _component_PhotosListTableComponent = _resolveComponent("PhotosListTableComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.editingFolder !== null && _ctx.editingFolder?.slug != 'trash')
      ? (_openBlock(), _createBlock(_component_EditFolderComponent, {
          key: `edit-folder-${_ctx.editingFolder?.slug}`,
          "gallery-slug": _ctx.currentSlug,
          open: _ctx.showEditFolderForm,
          onClose: _ctx.closeEditFolder,
          onFolderDeleted: _ctx.handleFolderDeleted,
          folder: _ctx.editingFolder
        }, null, 8, ["gallery-slug", "open", "onClose", "onFolderDeleted", "folder"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ControlsMenuComponent, { class: "sm:mb-6" }),
      _createElementVNode("aside", _hoisted_2, [
        (_ctx.showPeopleBlock)
          ? (_openBlock(), _createBlock(_component_PeopleBlockComponent, {
              key: 0,
              "gallery-slug": _ctx.currentSlug,
              "selected-person": _ctx.selectedPerson,
              onSelectPerson: _ctx.selectPerson
            }, null, 8, ["gallery-slug", "selected-person", "onSelectPerson"]))
          : (_ctx.showPeoplePromoBlock)
            ? (_openBlock(), _createBlock(_component_PeoplePromoBlockComponent, {
                key: 1,
                available: _ctx.gallery.face_grouping_available === true
              }, null, 8, ["available"]))
            : _createCommentVNode("", true),
        (_ctx.isCurrentGallery)
          ? (_openBlock(), _createBlock(_component_FoldersListComponent, {
              key: 2,
              onSelectFolder: _ctx.selectFolder,
              onEditFolder: _ctx.handleEditFolder,
              "selected-folder": _ctx.selectedFolder,
              "gallery-slug": _ctx.currentSlug
            }, null, 8, ["onSelectFolder", "onEditFolder", "selected-folder", "gallery-slug"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.isCurrentGallery)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            ((!_ctx.selectedFolder || (_ctx.selectedFolder && _ctx.selectedFolder.slug !== 'trash')) && _ctx.user?.config?.is_uses_new_uploading)
              ? (_openBlock(), _createBlock(_component_PhotoUploaderV3Component, {
                  key: 0,
                  folder: _ctx.selectedFolder || undefined,
                  ref: "uploaderV3"
                }, null, 8, ["folder"]))
              : _createCommentVNode("", true),
            ((!_ctx.selectedFolder || (_ctx.selectedFolder && _ctx.selectedFolder.slug !== 'trash')) && !_ctx.user?.config?.is_uses_new_uploading && !_ctx.selectedPerson)
              ? (_openBlock(), _createBlock(_component_NewPhotoUploaderComponent, {
                  key: 1,
                  folder: _ctx.selectedFolder || undefined
                }, null, 8, ["folder"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_ctx.user?.config?.is_uses_new_uploading && (!_ctx.selectedFolder || _ctx.selectedFolder?.slug !== 'trash'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploaderV3Click && _ctx.uploaderV3Click(...args)), ["prevent"])),
                      type: "button",
                      class: "w-full inline-flex items-center justify-center gap-1.5 px-3 py-2 mb-2 text-sm font-medium text-gray-700 bg-white/70 hover:bg-white transition-colors cursor-pointer border border-dashed border-gray-300 hover:border-gray-400 rounded-md"
                    }, [
                      _createVNode(_component_ArrowUpTrayIcon, { class: "size-4" }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('photo_uploader.upload_files')), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.selectedPerson === null && _ctx.selectedFolder !== null && _ctx.selectedFolder?.slug != 'trash')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleEditFolder(_ctx.selectedFolder)), ["prevent"])),
                        class: "inline-flex items-center gap-1 text-gray-700 px-1 text-sm font-medium whitespace-nowrap"
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('files.scene_files')) + ": ", 1),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.selectedFolder.title), 1),
                        _createVNode(_component_PencilSquareIcon, { class: "shrink-0 size-4 text-royal-blue-600 cursor-pointer" })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedPerson === null && _ctx.selectedFolder === null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('files.all_files')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.selectedPerson === null && _ctx.selectedFolder && _ctx.selectedFolder?.slug == 'trash')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('files.trashed_files')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.selectedPerson !== null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('people_block.person_photos')), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_Menu, {
                    as: "div",
                    class: "relative inline-block text-left ml-auto mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_MenuButton, { class: "inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-2 py-1.5 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-50 cursor-pointer" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_BarsArrowDownIcon, {
                              class: "size-5 text-gray-400",
                              "aria-hidden": "true"
                            }),
                            _createVNode(_component_ChevronDownIcon20, {
                              class: "-mr-1 size-5 text-gray-400 hidden",
                              "aria-hidden": "true"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_Transition, {
                        "enter-active-class": "transition ease-out duration-100",
                        "enter-from-class": "transform opacity-0 scale-95",
                        "enter-to-class": "transform opacity-100 scale-100",
                        "leave-active-class": "transition ease-in duration-75",
                        "leave-from-class": "transform opacity-100 scale-100",
                        "leave-to-class": "transform opacity-0 scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MenuItems, { class: "absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortOptions, (option) => {
                                  return (_openBlock(), _createBlock(_component_MenuItem, {
                                    key: option.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        disabled: option.value === 'manual',
                                        onClick: ($event: any) => (_ctx.order_by = option.value),
                                        class: _normalizeClass([
                                                            _ctx.order_by == option.value ? 'bg-gray-100 text-gray-900 outline-hidden' : 'text-gray-700',
                                                            option.value === 'manual' ? 'cursor-default' : 'cursor-pointer',
                                                            'hover:bg-gray-50 block px-4 py-2 text-sm text-left w-full'
                                                        ])
                                      }, _toDisplayString(option.name), 11, _hoisted_12)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.layout = 'list'), ["prevent"])),
                      type: "button",
                      class: _normalizeClass(['rounded-md p-1 cursor-pointer transition-all duration-150', _ctx.layout === 'list' ? 'bg-gray-100 text-gray-600' : 'text-gray-400 hover:text-gray-600'])
                    }, [
                      _createVNode(_component_Bars4Icon, {
                        class: "size-5",
                        "aria-hidden": "true"
                      }),
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "sr-only" }, "Use list view", -1))
                    ], 2),
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.layout = 'grid'), ["prevent"])),
                      type: "button",
                      class: _normalizeClass(['rounded-md p-1 cursor-pointer transition-all duration-150', _ctx.layout === 'grid' ? 'bg-gray-100 text-gray-600' : 'text-gray-400 hover:text-gray-600'])
                    }, [
                      _createVNode(_component_Squares2X2IconMini, {
                        class: "size-5",
                        "aria-hidden": "true"
                      }),
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "sr-only" }, "Use grid view", -1))
                    ], 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("nav", _hoisted_16, [
                    (_ctx.selectedPerson === null && _ctx.selectedFolder !== null && _ctx.selectedFolder?.slug != 'trash')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "#",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.handleEditFolder(_ctx.selectedFolder)), ["prevent"])),
                          class: "inline-flex items-center gap-1 border-transparent text-gray-700 border-b-2 px-1 py-4 text-sm font-medium whitespace-nowrap"
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('files.scene_files')) + ": ", 1),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.selectedFolder.title), 1),
                          _createVNode(_component_PencilSquareIcon, { class: "shrink-0 size-4 text-royal-blue-600 cursor-pointer" })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedPerson === null && _ctx.selectedFolder === null)
                      ? (_openBlock(), _createElementBlock("a", _hoisted_18, _toDisplayString(_ctx.$t('files.all_files')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectedPerson === null && _ctx.selectedFolder && _ctx.selectedFolder?.slug == 'trash')
                      ? (_openBlock(), _createElementBlock("a", _hoisted_19, _toDisplayString(_ctx.$t('files.trashed_files')), 1))
                      : _createCommentVNode("", true),
                    (_ctx.selectedPerson !== null)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 3,
                          href: "#",
                          onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.selectPerson(null)), ["prevent"])),
                          class: "inline-flex items-center gap-1 border-transparent text-gray-700 border-b-2 px-1 py-4 text-sm font-medium whitespace-nowrap"
                        }, _toDisplayString(_ctx.$t('people_block.person_photos')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.user?.config?.is_uses_new_uploading && (!_ctx.selectedFolder || _ctx.selectedFolder?.slug !== 'trash'))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploaderV3Click && _ctx.uploaderV3Click(...args)), ["prevent"])),
                        type: "button",
                        class: "inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium text-gray-700 bg-white/70 border border-dashed border-gray-300 hover:border-gray-400 hover:bg-white transition-colors cursor-pointer"
                      }, [
                        _createVNode(_component_ArrowUpTrayIcon, { class: "size-4" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('photo_uploader.upload_files')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_Menu, {
                      as: "div",
                      class: "relative inline-block text-left"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_MenuButton, { class: "inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-2 py-1.5 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-50 cursor-pointer" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_BarsArrowDownIcon, {
                                class: "size-5 text-gray-400",
                                "aria-hidden": "true"
                              }),
                              _createVNode(_component_ChevronDownIcon20, {
                                class: "-mr-1 size-5 text-gray-400 hidden",
                                "aria-hidden": "true"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(_Transition, {
                          "enter-active-class": "transition ease-out duration-100",
                          "enter-from-class": "transform opacity-0 scale-95",
                          "enter-to-class": "transform opacity-100 scale-100",
                          "leave-active-class": "transition ease-in duration-75",
                          "leave-from-class": "transform opacity-100 scale-100",
                          "leave-to-class": "transform opacity-0 scale-95"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_MenuItems, { class: "absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_21, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortOptions, (option) => {
                                    return (_openBlock(), _createBlock(_component_MenuItem, {
                                      key: option.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("button", {
                                          type: "button",
                                          disabled: option.value === 'manual',
                                          onClick: ($event: any) => (_ctx.order_by = option.value),
                                          class: _normalizeClass([
                                                            _ctx.order_by == option.value ? 'bg-gray-100 text-gray-900 outline-hidden' : 'text-gray-700',
                                                            option.value === 'manual' ? 'cursor-default' : 'cursor-pointer',
                                                            'hover:bg-gray-50 block px-4 py-2 text-sm text-left w-full'
                                                        ])
                                        }, _toDisplayString(option.name), 11, _hoisted_22)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("button", {
                        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.layout = 'list'), ["prevent"])),
                        type: "button",
                        class: _normalizeClass(['rounded-md p-1 cursor-pointer transition-all duration-150', _ctx.layout === 'list' ? 'bg-gray-100 text-gray-600' : 'text-gray-400 hover:text-gray-600'])
                      }, [
                        _createVNode(_component_Bars4Icon, {
                          class: "size-5",
                          "aria-hidden": "true"
                        }),
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "sr-only" }, "Use list view", -1))
                      ], 2),
                      _createElementVNode("button", {
                        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.layout = 'grid'), ["prevent"])),
                        type: "button",
                        class: _normalizeClass(['rounded-md p-1 cursor-pointer transition-all duration-150', _ctx.layout === 'grid' ? 'bg-gray-100 text-gray-600' : 'text-gray-400 hover:text-gray-600'])
                      }, [
                        _createVNode(_component_Squares2X2IconMini, {
                          class: "size-5",
                          "aria-hidden": "true"
                        }),
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "sr-only" }, "Use grid view", -1))
                      ], 2)
                    ])
                  ])
                ])
              ])
            ]),
            (_ctx.layout === 'grid')
              ? (_openBlock(), _createBlock(_component_PhotosListComponent, {
                  key: 2,
                  onOrderByUpdated: _ctx.orderByUpdated,
                  onPhotoMoved: _ctx.handlePhotoMoved,
                  layout: _ctx.gallery.design.layout,
                  "small-grid": _ctx.smallGrid,
                  folder: _ctx.selectedFolder || undefined
                }, null, 8, ["onOrderByUpdated", "onPhotoMoved", "layout", "small-grid", "folder"]))
              : _createCommentVNode("", true),
            (_ctx.layout === 'list')
              ? (_openBlock(), _createBlock(_component_PhotosListTableComponent, {
                  key: 3,
                  onOrderByUpdated: _ctx.orderByUpdated,
                  onPhotoMoved: _ctx.handlePhotoMoved,
                  layout: _ctx.gallery.design.layout,
                  "small-grid": _ctx.smallGrid,
                  folder: _ctx.selectedFolder || undefined
                }, null, 8, ["onOrderByUpdated", "onPhotoMoved", "layout", "small-grid", "folder"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}